// extracted by mini-css-extract-plugin
export const featuredMedia = "index-module--featuredMedia--2qmzg";
export const featuredMediaDescription = "index-module--featuredMediaDescription--JfCsI";
export const aboutSectionFeatures = "index-module--aboutSectionFeatures--QjrFr";